export enum AccountStatus {
  Active = 'ACTIVE',
  Provisioned = 'PROVISIONED'
}

export enum ActionType {
  Alert = 'ALERT',
  Reminder = 'REMINDER'
}

export enum ActivityInboxType {
  IssueMessageCreated = 'ISSUE_MESSAGE_CREATED',
  IssueUpdated = 'ISSUE_UPDATED'
}

export enum ActivityOption {
  Mentioned = 'MENTIONED',
  NotScheduled = 'NOT_SCHEDULED',
  Pinned = 'PINNED',
  Scheduled = 'SCHEDULED'
}

export enum ActivityType {
  AssetCreated = 'ASSET_CREATED',
  BlueCreated = 'BLUE_CREATED',
  CampaignCreated = 'CAMPAIGN_CREATED',
  FeatureToggleUpdated = 'FEATURE_TOGGLE_UPDATED',
  GreenCreated = 'GREEN_CREATED',
  GroupCreated = 'GROUP_CREATED',
  IssueDeleted = 'ISSUE_DELETED',
  IssueUpdated = 'ISSUE_UPDATED',
  MediaOpened = 'MEDIA_OPENED',
  MessageCreated = 'MESSAGE_CREATED',
  PurpleCreated = 'PURPLE_CREATED',
  RedCreated = 'RED_CREATED',
  TagScanCreated = 'TAG_SCAN_CREATED',
  UserJoined = 'USER_JOINED',
  UserJoinedWorkspace = 'USER_JOINED_WORKSPACE',
  UserLeftWorkspace = 'USER_LEFT_WORKSPACE',
  YellowCreated = 'YELLOW_CREATED'
}

export enum AlertStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export enum CallState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Ended = 'ENDED',
  Ringing = 'RINGING'
}

export enum CampaignStatus {
  Draft = 'DRAFT',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT'
}

export enum FeatureName {
  AccountPage = 'ACCOUNT_PAGE',
  ActivitySortFilter = 'ACTIVITY_SORT_FILTER',
  Alerts = 'ALERTS',
  AssetGrouping = 'ASSET_GROUPING',
  AssetSortFilter = 'ASSET_SORT_FILTER',
  BulkInvites = 'BULK_INVITES',
  CampaignsPage = 'CAMPAIGNS_PAGE',
  CommunicationPlatform = 'COMMUNICATION_PLATFORM',
  CropCircleRedesign = 'CROP_CIRCLE_REDESIGN',
  FilesPage = 'FILES_PAGE',
  GroupsPage = 'GROUPS_PAGE',
  IssueMessageReaction = 'ISSUE_MESSAGE_REACTION',
  Mentions = 'MENTIONS',
  MobileAlertsFlow = 'MOBILE_ALERTS_FLOW',
  NewRegistrationFlow = 'NEW_REGISTRATION_FLOW',
  NewRoutinesPage = 'NEW_ROUTINES_PAGE',
  OemHomeDashboard = 'OEM_HOME_DASHBOARD',
  OrangeButton = 'ORANGE_BUTTON',
  PeopleGrouping = 'PEOPLE_GROUPING',
  PulseHomeDashboard = 'PULSE_HOME_DASHBOARD',
  ReassignIssue = 'REASSIGN_ISSUE',
  Routines = 'ROUTINES',
  SmsLogin = 'SMS_LOGIN'
}

export enum GeoJsonType {
  Point = 'Point'
}

export enum GrippLinkType {
  Asset = 'ASSET',
  Workspace = 'WORKSPACE'
}

/**
 * Entity type for the map plotting-mode toggle (Phase 2). Selecting a card plots
 * that entity's individual points; the default (no mode) plots aggregated
 * Locations. ASSET/ACTIVITY/ROUTINE are plottable, as is PRODUCT (one point per
 * located asset, tagged with the asset's product name). Campaigns/Customers are
 * not plottable.
 */
export enum HomeEntityType {
  Activity = 'ACTIVITY',
  Asset = 'ASSET',
  Product = 'PRODUCT',
  Routine = 'ROUTINE'
}

export enum IntegrationProvider {
  CaseIh = 'CASE_IH',
  Geotab = 'GEOTAB',
  JohnDeere = 'JOHN_DEERE',
  PublicApi = 'PUBLIC_API'
}

export enum IntegrationRunStatus {
  Failed = 'FAILED',
  Partial = 'PARTIAL',
  Success = 'SUCCESS'
}

export enum IntegrationSyncStatus {
  Idle = 'IDLE',
  Running = 'RUNNING'
}

export enum IssueCreationSource {
  Anonymousweb = 'ANONYMOUSWEB',
  Geotab = 'GEOTAB',
  JohnDeere = 'JOHN_DEERE',
  Scanner = 'SCANNER'
}

export enum IssueMessageType {
  AccessRequestMessage = 'ACCESS_REQUEST_MESSAGE',
  AccessRequestResolved = 'ACCESS_REQUEST_RESOLVED',
  ReminderMessage = 'REMINDER_MESSAGE',
  RoutineExceptionMessage = 'ROUTINE_EXCEPTION_MESSAGE',
  RoutineMessage = 'ROUTINE_MESSAGE',
  RoutinePromptMessage = 'ROUTINE_PROMPT_MESSAGE',
  SystemMessage = 'SYSTEM_MESSAGE',
  SystemMessageReminderAlert = 'SYSTEM_MESSAGE_REMINDER_ALERT',
  UserMessage = 'USER_MESSAGE'
}

export enum IssueType {
  AccessRequest = 'ACCESS_REQUEST',
  Alert = 'ALERT',
  AllGood = 'ALL_GOOD',
  Campaign = 'CAMPAIGN',
  Feedback = 'FEEDBACK',
  Note = 'NOTE',
  Reminder = 'REMINDER',
  Report = 'REPORT',
  Routine = 'ROUTINE'
}

export enum MediaStatus {
  Pending = 'PENDING',
  Processed = 'PROCESSED'
}

export enum MediaType {
  Audio = 'AUDIO',
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Link = 'LINK',
  Video = 'VIDEO'
}

export enum RoleType {
  Account = 'ACCOUNT',
  System = 'SYSTEM'
}

export enum RoutineType {
  Counter = 'COUNTER',
  QuickConfirm = 'QUICK_CONFIRM',
  Status = 'STATUS',
  Workflow = 'WORKFLOW'
}

export enum ScheduleDays {
  EveryDay = 'EVERY_DAY',
  WeekDays = 'WEEK_DAYS'
}

export enum Severity {
  Blue = 'blue',
  Green = 'green',
  Purple = 'purple',
  Red = 'red',
  Yellow = 'yellow'
}

export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum TagBatchStatus {
  Delivered = 'DELIVERED',
  Ordered = 'ORDERED',
  Printer = 'PRINTER',
  Provisioned = 'PROVISIONED',
  Shipping = 'SHIPPING'
}

export enum TagStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum TriggerType {
  Issue = 'ISSUE',
  Routine = 'ROUTINE'
}

export enum WorkspaceType {
  Oem = 'OEM',
  Producer = 'PRODUCER'
}
